import { ZAP_APP_PATH_PREFIXES } from '@ctw/shared/utils/url';

// Matches the standalone app's own native pathname shape, `/patients/<upid>/{page}`,
// capturing the `/{page}` remainder (or an empty string for the patient-root page).
// Requires a non-empty id segment so the patients *list* page (`/patients`, no
// trailing segment) and unrelated routes that merely start with the string
// `/patients` (e.g. `/patientsomething`) don't match.
const STANDALONE_PATIENT_PATH_REGEX = /^\/patients\/[^/]+((?:\/.*)?)$/;

// Rewrites a ZAP/smart-on-fhir pathname, or the standalone app's own native
// `/patients/<upid>/{page}` pathname, to the canonical DataDog RUM view name
// `/patients/?/{page}`. For ZAP/smart-on-fhir this strips the app-specific mount
// prefix (`/v2`, `/vim/v1`, `/zap-v2`, …); for standalone it collapses the UPID
// segment. The literal `?` is DataDog's group token, so a page groups together
// regardless of which app served it. Returns null when the pathname matches
// neither shape, so the caller leaves the automatic name alone.
export const computeCanonicalRumViewName = (pathname: string): string | null => {
  const standaloneMatch = pathname.match(STANDALONE_PATIENT_PATH_REGEX);
  if (standaloneMatch) {
    return `/patients/?${standaloneMatch[1]}`;
  }

  const prefix = ZAP_APP_PATH_PREFIXES.find(
    (candidate) => pathname === candidate || pathname.startsWith(`${candidate}/`),
  );
  if (prefix === undefined) {
    return null;
  }

  const page = pathname.slice(prefix.length);
  return `/patients/?${page}`;
};
